import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "../../assets/lang/ru";
import kz from "../../assets/lang/kz";
import ar from "../../assets/lang/ar";
import en from "../../assets/lang/en";

import {Cookies} from "react-cookie";
import {COOKIE_KEY, LANG_KEY} from "../"

const cookies = new Cookies()


const urlParams = new URLSearchParams(window.location.search);
const cookiesLang = urlParams.get('lang') || LANG_KEY.RU; 
// const cookiesLang = cookies.get(COOKIE_KEY.LANG)

const resources = {
  [LANG_KEY.RU]: ru,
  [LANG_KEY.KZ]: kz,
  [LANG_KEY.AR]: ar,
  [LANG_KEY.EN]: en,
}

i18n
  .use(initReactI18next)
  .init({
    resources: resources,
    // debug: process.env.NODE_ENV !== "production",
    debug: false,
    lng: cookiesLang ? cookiesLang : LANG_KEY.RU,
    fallbackLng: cookiesLang ? cookiesLang : LANG_KEY.RU,
    defaultNS: "common",
    ns: "common",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
